import firebase from 'firebase/app'
import 'firebase/firebase-messaging'

const firebaseConfig = {
  apiKey: 'AIzaSyBDlSg-tPylygBZd5FaMWyNlMO9BPSEz_0',
  authDomain: 'fixpert-f6d99.firebaseapp.com',
  projectId: 'fixpert-f6d99',
  storageBucket: 'fixpert-f6d99.appspot.com',
  messagingSenderId: '462177201301',
  appId: '1:462177201301:web:585227a32b048c2507ff9c'
}

firebase.initializeApp(firebaseConfig)

export default firebase.messaging.isSupported() ? firebase.messaging() : {}
